import { render, staticRenderFns } from "./UsageReport.vue?vue&type=template&id=bf0aadc0&"
import script from "./UsageReport.vue?vue&type=script&lang=js&"
export * from "./UsageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/usage/UsageReport.vue
// module id = 1378
// module chunks = 0